import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFaceFrown } from '@fortawesome/free-solid-svg-icons';
import "./index.scss";
const NoRecord2 = ({ className = '' }) => {
	return (
		<>
			<div className={`no-data-blc2 d-flex align-items-center justify-content-center text-center h-100 ${className}`}>
				<div className="inner">
					<span className="d-inline-flex">
						<FontAwesomeIcon icon={faFaceFrown} />
					</span>
					<h2>
						{/* <span>Oops!!</span> */}
						No Record Found
					</h2>
				</div>
			</div>
		</>
	)
}

export default NoRecord2;